import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import {
  ChartAnchoredTooltip,
  ChartTooltip,
  useChartPayloadTop,
} from '../../../Chart'
import { formatBirdviewChartDate } from '../../DashboardBirdview.utils.charts'

import { getBirdviewFlowTooltipRows } from './BirdviewFlowTooltip.utils'

function BirdviewFlowTooltip({ active, label, payload = EMPTY_LIST }) {
  const { t } = useTranslation()

  const top = useChartPayloadTop(payload)

  return active && payload.length > 0 ? (
    <ChartAnchoredTooltip top={top}>
      <ChartTooltip
        rows={getBirdviewFlowTooltipRows({ payload, t })}
        title={formatBirdviewChartDate(label)}
      />
    </ChartAnchoredTooltip>
  ) : null
}

export default BirdviewFlowTooltip
